module.exports = __webpack_public_path__ + "img/photo-0034.c885b362.jpg";